import React from 'react';
import { Box, useTheme } from '@mui/material';

export default function ContainerGrid({ 
  container = false, 
  spacing = 0, 
  size, 
  children, 
  sx = {}, 
  ...props 
}) {
  // Lấy breakpoint trực tiếp từ MUI Theme để đồng nhất với component ResponsiveContainerHidden
  const theme = useTheme();
  const breakpoints = theme.breakpoints.values; // { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 }
  
  // ==========================================
  // NẾU COMPONENT LÀ WRAPPER (CONTAINER)
  // ==========================================
  if (container) {
    return (
      <Box
        sx={{
          // Kích hoạt Container Queries
          containerType: 'inline-size',
          containerName: 'responsive-grid',
          
          // Định nghĩa hệ thống 12 cột y hệt MUI Grid
          display: 'grid',
          gridTemplateColumns: 'repeat(12, 1fr)',
          
          // MUI tự động nhân spacing với 8px (vd: spacing={2} -> gap: 16px)
          gap: spacing, 
          width: '100%',
          ...sx
        }}
        {...props}
      >
        {children}
      </Box>
    );
  }

  // ==========================================
  // NẾU COMPONENT LÀ ITEM BÊN TRONG
  // ==========================================
  
  // Hàm tạo CSS dựa trên số cột (tối đa 12)
  const getSpanCss = (col) => `span ${col} / span ${col}`;
  
  let itemSx = {};
  
  // Xử lý khi truyền size là một số (vd: size={6})
  if (typeof size === 'number') {
    itemSx = { gridColumn: getSpanCss(size) };
  } 
  // Xử lý khi truyền Object breakpoint (vd: size={{ xs: 12, md: 6 }})
  else if (typeof size === 'object' && size !== null) {
    
    // XỬ LÝ BREAKPOINT XS:
    // Theo nguyên tắc Mobile-First, xs (từ 0px trở lên) chính là class mặc định.
    // Nếu truyền size.xs thì dùng, nếu không có thuộc tính nào được truyền thì mặc định chiếm 12 cột.
    itemSx.gridColumn = getSpanCss(size.xs || 12);

    // Bơm dần các rule @container vào thuộc tính sx dựa trên theme MUI
    // Tự động sinh rule cho sm, md, lg, xl nếu có truyền vào prop size
    ['sm', 'md', 'lg', 'xl'].forEach((key) => {
      if (size[key] !== undefined) {
        // Sử dụng giá trị pixel được lấy thẳng từ theme.breakpoints
        itemSx[`@container responsive-grid (min-width: ${breakpoints[key]}px)`] = { 
          gridColumn: getSpanCss(size[key]) 
        };
      }
    });

  } 
  // Mặc định an toàn
  else {
    itemSx.gridColumn = getSpanCss(12);
  }

  return (
    <Box sx={{ ...itemSx, ...sx }} {...props}>
      {children}
    </Box>
  );
}